import React from 'react'
import { Button } from '@mui/material';
import { useSelector } from "react-redux";

import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';

const CoreFilterButtonIcon = ({ onOpen }) => {
    const colorPrimary = useSelector((state) => state.app.primaryColor);
    return (
        <Button
            onClick={onOpen}
            variant="outlined"
            style={{ minWidth: '5px', color: `${colorPrimary}`, borderColor: `${colorPrimary}` }}
        >
            <FilterAltRoundedIcon />
        </Button>
    )
}

export default CoreFilterButtonIcon